import moment from "moment";
import { StyleSheet } from "react-native";
import { View, Text } from "../../../components/Themed";
import Colors from "../../../constants/Colors";

const headerDate = (openHouse: any) => {
  const { start_date, start_time, end_time } = openHouse;

  return `${moment(start_date).format("ddd, MMMM D, YYYY")} ${moment(
    `${moment(start_date).format("YYYY-MM-DD")} ${start_time}`,
    "YYYY-MM-DD HH:mm:ss"
  ).format("h:mm A")} - ${moment(
    `${moment(start_date).format("YYYY-MM-DD")} ${end_time}`,
    "YYYY-MM-DD HH:mm:ss"
  ).format("h:mm A")}`;
};

export const PageTitleContainer = (props: any) => (
  <View darkColor={Colors.nuetral_grey_700} style={styles.pageTitleContainer}>
    {props.children}
  </View>
);

export const PageTitleAddress = ({ address }: { address: string }) => (
  <Text
    size={18}
    numberOfLines={1}
    lineHeight={24}
    weight="SemiBold"
    lightColor={Colors.nuetral_grey_700}
  >
    {address}
  </Text>
);

export const PageTitleDate = ({
  openHouse,
  isTablet,
}: {
  openHouse: any;
  isTablet: boolean;
}) => (
  <Text
    size={isTablet ? 16 : 14}
    numberOfLines={1}
    lightColor={Colors.nuetral_grey_600}
  >
    {headerDate(openHouse)}
  </Text>
);

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  pageTitleContainer: {
    marginTop: 10,
    marginBottom: -10,
    alignItems: "center",
    justifyContent: "center",
  },
});
